import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../CommonComponent/Loader";
import { jwtDecode } from "jwt-decode";
import { apiRequestGet, apiRequestPost } from "../../Helper/Api";
import { useDispatch } from "react-redux";
import { authLogin, setToken } from "../../Redux/Auth/AuthSlice";
import Swal from "sweetalert2";
import { persistor } from "../../Redux/store";
import { FaEye,FaEyeSlash } from "react-icons/fa6";


const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [noHp, setNoHp] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [show,setShow] = useState(false)

  const handleLogin = async () => {
    persistor.purge();
    localStorage.clear();
    setLoading(true);

    if(noHp === "" || password === ""){
      Swal.fire({
        title: "Gagal",
          text: "Username atau Password harus diisi",
          icon: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
          allowEscapeKey: false,
      })
    }
    try {
      const url = "/auth/login";
      const payload = {
        no_hp: noHp,
        password: password,
      };
      const { error, result } = await apiRequestPost(url, payload);

      if (!error) {
        let data = await jwtDecode(result);
        dispatch(setToken({ token: result }));
        const roles = ["SUPERADMIN","ASM","RSM"]

        const urlPermission = "/auth/permission";
        const paramsPermission = {
          id: data.menu_permission,
        };
        const dataPermission = await apiRequestGet(
          urlPermission,
          paramsPermission
        );

        if (dataPermission.result) {
          data.permission = dataPermission.result;
        }

        const urlMenu = "/auth/menu";
        const paramsMenu = {
          id: data.id,
        };
        const dataMenu = await apiRequestPost(
          urlMenu,
          paramsMenu
        );

        if (dataMenu.result) {
          console.log({dataMenu})
          data.menu = dataMenu.result.menu;
        }

        if (dataPermission.result) {
          data.permission = dataPermission.result;
        }

        dispatch(authLogin(data));

        if (data.role === "KASIR") {
          navigate("/transaksi/manajemen-kasir");
        } else if(roles.includes(data.role)){
          navigate("/administrator/user")
        }else{
          navigate("/dashboard/transaksi");
        }
      } else {
        Swal.fire({
          title: "Gagal",
          text: result,
          icon: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="flex flex-wrap items-center">
          <div className="hidden w-full xl:block xl:w-1/2">
            <div className="py-17.5 px-26 text-center">
              <Link className="mb-5.5 inline-block" to="/">
                <img
                  className="hidden dark:block"
                  src="https://gp-production-img.s3.ap-southeast-1.amazonaws.com/corp-img/logolight.png"
                  alt="Logo"
                  style={{ width: 200, height: "auto" }}
                />
                <img
                  className="dark:hidden"
                  src="https://gp-production-img.s3.ap-southeast-1.amazonaws.com/corp-img/logolight.png"
                  alt="Logo"
                  style={{ width: 200, height: "auto" }}
                />
              </Link>

              <p className="2xl:px-20">
                Memberdayakan Warung, dimana Tradisi Bertemu Inovasi
              </p>

              <span className="mt-15 inline-block">
                <img
                  src="https://gp-production-img.s3.ap-southeast-1.amazonaws.com/corp-img/logokucing.png"
                  alt="kucing-pink"
                />
              </span>
            </div>
          </div>

          <div className="w-full border-stroke dark:border-strokedark xl:w-1/2 xl:border-l-2">
            <div className="w-full p-4 sm:p-12.5 xl:p-17.5">
              <span className="mb-1.5 block font-medium"></span>
              <h2 className="mb-9 text-2xl font-bold text-black dark:text-white sm:text-title-xl2">
                Sign In to POS Bersama
              </h2>
           
              <form className={``}>
                <div className="mb-4">
                  <label className="mb-2.5 block font-medium text-black dark:text-white">
                    No.Hp
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      placeholder="Enter your mobile phone number"
                      className="w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-10 outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                      onChange={(e) => setNoHp(e.target.value)}
                      onKeyDown={(e)=>handleKeyDown(e)}
                    />

                    <span className="absolute right-4 top-4">
                     
                    </span>
                  </div>
                </div>

                <div className="mb-6">
                  <label className="mb-2.5 block font-medium text-black dark:text-white">
                    Password
                  </label>
                  <div className="relative">
                    <input
                      type={show? 'text':'password'}
                      placeholder="type your password"
                      className="w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-10 outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyDown={(e)=>handleKeyDown(e)}
                    />

                    <span className="absolute right-4 top-4" onClick={()=>setShow(!show)}>
                     {show ? <FaEyeSlash className="w-8 h-6 text-gray-500" /> : <FaEye className="w-8 h-6 text-gray-500" />} 
                    </span>
                  </div>
                </div>

                <div className="mb-5">
                  <input
                    type="button"
                    value="Sign In"
                    className="w-full cursor-pointer rounded-lg border border-bersama bg-bersama p-4 text-white transition hover:bg-opacity-90"
                    onClick={() => handleLogin()}
                  />
                </div>

                <div className="mb-5">
                  <input
                    type="button"
                    value="Bantuan"
                    className="w-full cursor-pointer rounded-lg border text-bersama bg-transparent p-4  transition hover:bg-opacity-90"
                    onClick={() => window.open("https://drive.google.com/file/d/1TwPm_IWz_Rmks7g3YWN57ueYDgVUeXTA/view?usp=sharing")}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignIn;
